import { Col, Form, Row } from "antd";
import QuestionOptionContent from "./QuestionOptionContent";

const TEXT_INPUT_TYPES = ["Text (Input)", "Number (Input)"];

export default function QuestionContent(props) {
	const {
		namePath = [],
		question = null,
		description = null,
		type = null,
		required = false,
		max_checkbox = 0,
		add_another = false,
		form_question_options = [],
	} = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	return (
		<Row>
			<Col
				xs={24}
				sm={24}
				md={24}
				lg={24}
				xl={24}
				style={
					Array.isArray(namePath) && namePath.length > 0
						? { paddingLeft: 20 }
						: {}
				}
			>
				<QuestionOptionContent
					question={question}
					description={description}
					namePath={newNamePath}
					type={type}
					required={required}
					max_checkbox={max_checkbox}
					add_another={add_another}
					form_question_options={
						form_question_options.length > 0 ? form_question_options : []
					}
				/>
			</Col>
			{/* shouldUpdate (not dependencies) so programmatic setFieldValue also re-renders sub options */}
			<Form.Item
				noStyle
				shouldUpdate={(prev, cur) => prev[newNamePath] !== cur[newNamePath]}
			>
				{({ getFieldValue }) => {
					const selectedOption = getFieldValue(newNamePath);

					// Free-text inputs reveal all their sub options once answered
					if (TEXT_INPUT_TYPES.includes(type)) {
						if (add_another) {
							return null;
						}

						const answered =
							selectedOption !== undefined &&
							selectedOption !== null &&
							String(selectedOption).trim() !== "";

						if (!answered) {
							return null;
						}

						return form_question_options
							.filter((option) => !option.is_other)
							.map((option) => (
								<Col
									key={`${newNamePath}_qo_${option.id}`}
									xs={24}
									sm={24}
									md={24}
									lg={24}
									xl={24}
									style={{ paddingLeft: 20 }}
								>
									<QuestionContent
										namePath={`${newNamePath}_qo_${option.id}`}
										question={option.question_option || option.option}
										type={option.sub_option_type}
										required={option.required ? true : false}
										max_checkbox={option.max_checkbox || 0}
										escape_questions={option.escape_questions || []}
										form_question_options={option.form_question_options || []}
									/>
								</Col>
							));
					}

					if (type === "Checkbox") {
						const selectedArray = Array.isArray(selectedOption)
							? selectedOption
							: [];

						if (!selectedArray.length) {
							return null;
						}

						const selectedOptions = form_question_options.filter(
							(option) =>
								option.sub_option_type &&
								selectedArray.includes(option.option),
						);

						if (!selectedOptions.length) {
							return null;
						}

						return selectedOptions.map((form_question_option) => {
							let newQuestion =
								form_question_option.question_option ||
								(form_question_option.sub_option_type === "sub_question"
									? form_question_option.option
									: null);
							let newType = form_question_option.sub_option_type || null;
							let newRequired = form_question_option.required ? true : false;
							let newMaxCheckbox = form_question_option.max_checkbox || 0;
							let newEscapeQuestions =
								form_question_option.escape_questions || [];
							let newFormQuestionOptions =
								form_question_option.form_question_options || [];

							return (
								<Col
									key={`${newNamePath}_qo_${form_question_option.id}`}
									xs={24}
									sm={24}
									md={24}
									lg={24}
									xl={24}
									style={{
										paddingLeft: 20,
									}}
								>
									<QuestionContent
										namePath={`${newNamePath}_qo_${form_question_option.id}`}
										question={newQuestion}
										type={newType}
										required={newRequired}
										max_checkbox={newMaxCheckbox}
										escape_questions={newEscapeQuestions}
										form_question_options={newFormQuestionOptions}
									/>
								</Col>
							);
						});
					}

					let form_question_option = form_question_options.find(
						(option) => option.option === selectedOption,
					);

					if (form_question_option?.sub_option_type) {
						let newQuestion = form_question_option.question_option || null;
						let newType = form_question_option.sub_option_type || null;
						let newRequired = form_question_option.required ? true : false;
						let newMaxCheckbox = form_question_option.max_checkbox || 0;
						let newEscapeQuestions =
							form_question_option.escape_questions || [];
						let newFormQuestionOptions =
							form_question_option.form_question_options || [];

						return (
							<Col
								xs={24}
								sm={24}
								md={24}
								lg={24}
								xl={24}
								style={{
									paddingLeft: 20,
								}}
							>
								<QuestionContent
									namePath={`${newNamePath}_qo_${form_question_option.id}`}
									question={newQuestion}
									type={newType}
									required={newRequired}
									max_checkbox={newMaxCheckbox}
									escape_questions={newEscapeQuestions}
									form_question_options={newFormQuestionOptions}
								/>
							</Col>
						);
					}

					return null;
				}}
			</Form.Item>
		</Row>
	);
}
